import React, { createContext, useState, useEffect } from 'react';
import axios from '../utils/service';
import {baseURL} from "../utils/consts";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('userData')));
  const [token, setToken] = useState(localStorage.getItem('userToken'));
  const login = async (emailOrUsername, password) => {
    console.log(`baseURL: ${baseURL} ${process.env.NODE_ENV}`);
    const { data } = await axios.post(`/auth/login`, { emailOrUsername, password });
    localStorage.setItem('userToken', data.token);
    localStorage.setItem('userData', JSON.stringify(data));
    setToken(data.token);
    setUser(data);
  };

  const refresh_user = async () => {
    const token = user?.token;
    if(token) {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const {data} = await axios.get(`/auth/me`, config);
      localStorage.setItem('userData', data);
      setUser(data);
    }
  };

  const logout = async () => {
    const { data } = await axios.post(`/auth/logout`);
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    setToken(null);
    setUser(null);
  };

  const register = async (username, email, password, acceptedTOS, acceptedCA) => {
    const { data } = await axios.post(`/auth/register`, { username, email, password, acceptedTOS, acceptedCA});
    localStorage.setItem('userData', JSON.stringify(data));
    setToken(null);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, register, refresh_user }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
